<template>
  <div class="university-management" dir="rtl">
    <div class="container">
      <div class="header">
        <h1 class="page-title">إدارة الجامعات</h1>
        <button class="btn btn-add" @click="openModalForAdd">
          إضافة جامعة جديدة
        </button>
      </div>

      
<div class="table-section">
  <div class="table-header">
        <h2 class="table-title">قائمة الجامعات</h2>
      </div>
  <div class="table-responsive">
          <table class="universities-table">
            <thead>
              <tr>
                <th>التسلسل</th>
                <th>اسم الجامعة</th>
                <th>الإجراءات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(uni, index) in filteredUniversities" 
                  :key="uni.id"
                  :class="{ 'is-deleting': uni.isDeleting }"
              >
                <td>{{ (pageNumber - 1) * pageSize + (index + 1) }}</td>
                <td>
                  <div class="university-name">{{ uni.name }}</div>
                </td>
              
                <td>
                  <div class="row-actions">
                    <button class="action-btn edit" @click="openModalForEdit(uni)">
                      <span class="action-icon">✎</span>
                      تعديل
                    </button>
                    <button class="action-btn delete" @click="deleteUniversity(uni.id)">
                      <span class="action-icon">×</span>
                      حذف
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr v-if="universities.length === 0">
                <td colspan="4" class="empty-state">
                  <div class="empty-icon">🏛️</div>
                  <h3>لا توجد جامعات</h3>
                  <p>قم بإضافة جامعة جديدة للبدء</p>
                </td>
              </tr>
            </tbody>
          </table>
      </div>

      <custom-pagination
        :currentPage="pageNumber"
        :totalPages="totalPages"
        @page-changed="handlePageChange"
      />
</div>
    

      <div class="modal-overlay" v-if="showModal" @click.self="closeModal">
        <div class="modal-content">
          <h2 class="modal-title">
            {{ isEditMode ? "تعديل الجامعة" : "إضافة جامعة جديدة" }}
          </h2>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name" class="form-label">اسم الجامعة</label>
              <input
                type="text"
                id="name"
                v-model="form.name"
                class="form-control"
                placeholder="أدخل اسم الجامعة"
                required
              />
            </div>
            <div class="modal-actions">
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? "تحديث الجامعة" : "إضافة الجامعة" }}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeModal"
              >
                إغلاق
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import Swal from "sweetalert2";
import CustomPagination from "@/components/CustomPagination.vue";

export default {
  name: "UniversityManagement",
  components: { CustomPagination },
  data() {
    return {
      universities: [],
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      showModal: false,
      isEditMode: false,
      
      form: {
        id: null,
        name: "",
      },
    };
  },
  computed: {
    filteredUniversities() {
      return this.universities;
    },
  },
  methods: {

    async getAllUniversities() {
      try {
        const response = await apiClient.get(
          "/api/Universities/GetAllUniversities",
          {
            params: {
              PageNumber: this.pageNumber,
              PageSize: this.pageSize,
            },
          }
        );
        if (response.data.items) {
          this.universities = response.data.items;
          this.totalPages = response.data.totalPages;
        } else {
          this.universities = response.data;
          this.totalPages = 1;
        }
      } catch (error) {
        console.error("حدث خطأ أثناء جلب الجامعات:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب الجامعات",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    handlePageChange(newPage) {
      this.pageNumber = newPage;
      this.getAllUniversities();
    },

    openModalForAdd() {
      this.resetForm();
      this.isEditMode = false;
      this.showModal = true;
    },

    openModalForEdit(uni) {
      this.isEditMode = true;
      this.form.id = uni.id;
      this.form.name = uni.name;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.resetForm();
    },

    async handleSubmit() {
      try {
        if (this.isEditMode) {
          await apiClient.put(
            "/api/Universities/UpdateUniversity",
            { name: this.form.name },
            { params: { id: this.form.id } }
          );
          Swal.fire({
            icon: "success",
            title: "تم",
            text: "تم تحديث الجامعة بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          await apiClient.post("/api/Universities/AddUniversity", {
            name: this.form.name,
          });
          Swal.fire({
            icon: "success",
            title: "تم",
            text: "تم إضافة الجامعة بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
        }
        this.closeModal();
        this.getAllUniversities();
      } catch (error) {
        console.error("حدث خطأ أثناء معالجة العملية:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء معالجة العملية",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    async deleteUniversity(id) {
      const result = await Swal.fire({
        title: "تأكيد الحذف",
        text: "هل أنت متأكد من حذف الجامعة؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "نعم، احذفها",
        cancelButtonText: "إلغاء",
      });

      if (result.isConfirmed) {
        try {
          await apiClient.delete("/api/Universities/DeleteUniversity", {
            params: { id },
          });
          Swal.fire({
            icon: "success",
            title: "تم الحذف",
            text: "تم حذف الجامعة بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
          this.getAllUniversities();
        } catch (error) {
          console.error("حدث خطأ أثناء حذف الجامعة:", error);
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text: "حدث خطأ أثناء حذف الجامعة",
            timer: 3000,
            showConfirmButton: false,
          });
        }
      }
    },

    nextPage() {
      if (this.pageNumber < this.totalPages) {
        this.pageNumber++;
        this.getAllUniversities();
      }
    },

    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
        this.getAllUniversities();
      }
    },

    resetForm() {
      this.form = { id: null, name: "" };
      this.isEditMode = false;
    },
  },
  mounted() {
    this.getAllUniversities();
  },
};
</script>

<style scoped>
.university-management {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 3rem;
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  animation: slideDown 0.5s ease-out;
}

.page-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.page-subtitle {
  color: #718096;
  margin-bottom: 1.5rem;
}

.btn-add {
  background: #4299e1;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-add:hover {
  background: #3182ce;
  transform: translateY(-1px);
}

/* Table Section */
.table-container {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.table-title {
  font-size: 1.5rem;
  color: #2d3748;
  font-weight: 600;
  margin: 0;
}

.search-container {
  position: relative;
}

.search-input {
  padding: 0.5rem 2rem 0.5rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  width: 250px;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  outline: none;
}

.search-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #718096;
}

.table-responsive {
  overflow-x: auto;
  border-radius: 0.5rem;
}

.universities-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.universities-table th {
  background: #f7fafc;
  padding: 1rem;
  font-weight: 600;
  color: #4a5568;
  text-align: right;
  border-bottom: 2px solid #e2e8f0;
}

.universities-table td {
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s;
}

.universities-table tr:hover td {
  background: #f7fafc;
}

.university-name {
  font-weight: 500;
  color: #2d3748;
}

.student-count {
  background: #e2e8f0;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  color: #4a5568;
}

.row-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.action-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.action-btn.edit {
  background: #faf089;
  color: #744210;
}

.action-btn.edit:hover {
  background: #f6e05e;
}

.action-btn.delete {
  background: #fed7d7;
  color: #c53030;
}

.action-btn.delete:hover {
  background: #feb2b2;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.empty-state h3 {
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}

.empty-state p {
  color: #718096;
}

/* Modal Styles */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 1rem;
  width: 90%;
  max-width: 500px;
  position: relative;
  padding: 2rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.modal-title {
  font-size: 1.5rem;
  color: #2d3748;
  font-weight: 600;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #718096;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #2d3748;
}

/* Form Styles */
.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  outline: none;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.btn-submit {
  background: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-submit:hover:not(:disabled) {
  background: #3182ce;
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-cancel {
  background: #e2e8f0;
  color: #4a5568;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #cbd5e0;
}

/* Loading Spinner */
.spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid #ffffff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Animations */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-50%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animations */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes modalSlideIn {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Deletion Animation */
.is-deleting {
  animation: fadeOut 0.3s ease-out forwards;
}

@keyframes fadeOut {
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}

/* Modal Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .university-management {
    padding: 1rem;
  }

  .header {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .search-input {
    width: 100%;
  }

  .table-header {
    flex-direction: column;
    gap: 1rem;
  }

  .modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  .modal-actions {
    flex-direction: column-reverse;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }

  .row-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
  }
}

/* RTL Support */
[dir="rtl"] .modal-close {
  left: 1.5rem;
  right: auto;
}

[dir="rtl"] .form-control {
  text-align: right;
}

[dir="rtl"] .modal-actions {
  flex-direction: row-reverse;
}

[dir="rtl"] .search-icon {
  right: auto;
  left: 0.75rem;
}

[dir="rtl"] .search-input {
  padding: 0.5rem 1rem 0.5rem 2rem;
}
</style>
